import { z } from "zod";

//DiarioObrasParalisacoesSchema

// Helpers
const optionalNumber = z.coerce.number().int().nullable().optional();
const optionalString = z.coerce.string().trim().nullable().optional().transform(e => e === '' ? null : e);
const optionalBoolean = z.boolean().nullable().optional();

export const DiarioObrasParalisacoesSchema = z.object({
  IdDiarioObrasParalisacoes: z.number().int().default(0),
  IdDiarioObras: optionalNumber,
  HorarioInicio: optionalString,
  HorarioFim: optionalString,
  Motivo: optionalString.pipe(z.string().max(500, "Máximo de 500 caracteres").nullable().optional()),
  Assunto: optionalString.pipe(z.string().max(500, "Máximo de 500 caracteres").nullable().optional()),
  Delete: optionalBoolean,
  TempoParalisacao: optionalString,
});

export type DiarioObrasParalisacoesForm = z.infer<typeof DiarioObrasParalisacoesSchema>;